const isMobile = () => {
    return window.innerWidth < 1024;
};

export const UtilDevice = {
    isMobile
};